import { authFetch, getBackendUrl, parseJsonSafe } from "./memorialApi";

export async function fetchPendingTributesSummary() {
  try {
    const res = await authFetch(`${getBackendUrl()}/api/user/pending-tributes`);
    if (!res.ok) {
      return { items: [], totalCount: 0 };
    }
    const data = await parseJsonSafe(res);
    return data || { items: [], totalCount: 0 };
  } catch (e) {
    console.error("fetchPendingTributesSummary:", e);
    return { items: [], totalCount: 0 };
  }
}

export function getPendingTributesReviewUrl(memorialId, slug) {
  const base = typeof window !== "undefined" ? window.location.origin : "";
  return `${base}/profile/${slug || "memorial"}/${memorialId}?tab=pendingTributes`;
}

export function saveReturnUrl(path) {
  if (path && path !== "/login" && path !== "/signup") {
    sessionStorage.setItem("returnUrl", path);
  }
}

export function consumeReturnUrl(fallback = "/") {
  const url = sessionStorage.getItem("returnUrl");
  if (url) {
    sessionStorage.removeItem("returnUrl");
    return url;
  }
  return fallback;
}
